__turbopack_context__.v({
  "browse": "WbPKLW_browse",
  "browseAll": "WbPKLW_browseAll",
  "discoverGrid": "WbPKLW_discoverGrid",
  "feedCard": "WbPKLW_feedCard",
  "heading": "WbPKLW_heading",
  "inner": "WbPKLW_inner",
});
